import console from '@/services/ConsoleService'
import { MODAL_STATES, LOAD, APP_STATES } from 'src/config/app'

export const setVersion = (state, data) => {
  state.version.build = data.build
  state.version.date = data.date
}

// **************************************************
//
// LOADING
//
// **************************************************
export const setLoadProgress = (state, progress) => {
  state.loading.progress = Math.min(progress, 1)
}
export const setLoadState = (state, value) => {
  state.loading.state = value

  // set load step
  switch (value) {
    case LOAD.STATES.CRITICAL_LOADED:
      state.loading.steps[LOAD.GROUPS.CRITICAL] = true
      break
    case LOAD.STATES.MAIN_LOADED:
      state.loading.steps[LOAD.GROUPS.MAIN] = true
      break
  }
}
export const setLoadComplete = state => {
  state.loading.progress = 1
  state.loading.completed = true
}
export const setEpochOneTopOffset = (state, value) => {
  state.home.epochOneTopOffset = value
}
export const setHeaderHeightRatio = (state, value) => {
  state.header.heightRatio = value
}

// **************************************************
//
// ROUTE
//
// **************************************************
export const setRoute = (state, value) => {
  state.route.prev.parent = state.route.curr.parent
  state.route.prev.child = state.route.curr.child

  state.route.curr.parent = value.parent
  state.route.curr.child = value.child

  // don't set app state by route if loading, let loading modal handle it
  const isLoadingAppState = state.app_state == APP_STATES.LOADING || state.app_state === APP_STATES.LANDING
  if (!isLoadingAppState) {
    state.prev_app_state = state.app_state
    state.app_state = value.params.home_id ? value.params.home_id : value.parent
  }
}

export const setRouteAfterLoad = (state, value) => {
  state.route.afterLoad = value
}

export const setModalState = (state, value) => {
  state.prev_modal_state = state.modal_state
  state.modal_state = value
}

export const setAppState = (state, value) => {
  state.prev_app_state = state.app_state
  state.app_state = value
}

export const setScrollLock = (state, value) => {
  state.home.scrollLock = value
}

export const setHeaderId = (state, value) => {
  state.header.id = value
}

export const setHeaderUIVisible = (state, value) => {
  state.header.uiVisible = value
}

export const setSectionRectById = (state, value) => {
  state.home.sections[value.id] = value.rect
}

export const setHomeScrollPosition = (state, value) => {
  state.home.scrollPosition = value
}



